import { IList } from './list';
export var IRecord;
(function (IRecord) {
    IRecord.get = (record, key) => record[key];
    IRecord.set = (record, key, newValue) => (Object.assign(Object.assign({}, record), { [key]: newValue }));
    IRecord.update = (record, key, updater) => (Object.assign(Object.assign({}, record), { [key]: updater(record[key]) }));
    const UNSAFE_getIn_impl = (obj, keyPath, index) => index >= keyPath.length
        ? obj
        : UNSAFE_getIn_impl(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        obj[keyPath[index]], keyPath, index + 1);
    IRecord.getIn = (record, keyPath) => UNSAFE_getIn_impl(record, keyPath, 0);
    const UNSAFE_updateIn_impl = (obj, keyPath, index, updater) => index >= keyPath.length
        ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            updater(obj)
        : IList.isArray(obj)
            ? obj.map((v, i) => i === keyPath[index]
                ? UNSAFE_updateIn_impl(
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                obj[keyPath[index]], keyPath, index + 1, updater)
                : v)
            : Object.assign(Object.assign({}, obj), { 
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                [keyPath[index]]: UNSAFE_updateIn_impl(
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                obj[keyPath[index]], keyPath, index + 1, updater) });
    IRecord.setIn = (record, ...[keyPath, newValue]) => UNSAFE_updateIn_impl(record, keyPath, 0, () => newValue);
    IRecord.updateIn = (record, keyPath, updater) => UNSAFE_updateIn_impl(record, keyPath, 0, updater);
    IRecord.keys = (object) => 
    // eslint-disable-next-line no-restricted-globals
    Object.keys(object);
    IRecord.values = (object
    // eslint-disable-next-line no-restricted-globals
    ) => Object.values(object);
    IRecord.fromEntries = (entries_) => 
    // eslint-disable-next-line no-restricted-globals
    Object.fromEntries(entries_);
    IRecord.entries = (object
    // eslint-disable-next-line no-restricted-globals
    ) => Object.entries(object);
})(IRecord || (IRecord = {}));
